/* Aico Page Nav — smooth-scrolls to same-page anchor targets (#id).
   The landing offset is controlled by each target section's scroll-margin-top. */
(function () {
  'use strict';

  function initNav(root) {
    if (!root || root.dataset.pnInit === '1') return;
    root.dataset.pnInit = '1';

    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return; // let the browser handle unknown anchors
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-aico-pagenav]').forEach(initNav);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-aico-pagenav]') : null;
    if (el) initNav(el);
  });
})();
